import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status--disabled",
  "use": "status--disabled-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"status--disabled\">\n  <g fill=\"none\" fill-rule=\"nonzero\">\n    <circle cx=\"32\" cy=\"32\" r=\"24\" fill=\"#E24B0F\" />\n    <rect width=\"34\" height=\"10\" x=\"15\" y=\"27\" fill=\"#FFF\" rx=\"2\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol